export default __webpack_public_path__ + "static/show-up-announcement-8dc43bd1d38529806ed858399c590949.png";